// extracted by mini-css-extract-plugin
export var accordionBody = "style-mod--accordion-body--80216";
export var accordionContainer = "style-mod--accordion-container--1b6d7";
export var accordionContainerVarB = "style-mod--accordion-container-var-b--9abc4";
export var accordionIcon = "style-mod--accordion-icon--d5118";
export var accordionIconOpen = "style-mod--accordion-icon-open--4e967";
export var accordionTitle = "style-mod--accordion-title--ffa5e";
export var accrodionTitleIcon = "style-mod--accrodion-title-icon--f6393";
export var campaignImg = "style-mod--campaign-img--649ef";
export var pdpSnippetDesktop = "style-mod--pdp-snippet-desktop--ca457";
export var pdpSnippetMobile = "style-mod--pdp-snippet-mobile--44e2f";
export var toggleHeader = "style-mod--toggle-header--0ddb5";